module.exports = __webpack_public_path__ + "img/P1 (3).64f0a41f.png";